import {getBgStyling, loadingEffect} from "./library";

$(".btd-module-events").each(function (index, module) {
    const $module = $(module);
    const eventsEmpty = $('.events-empty', $module);
    const eventsError = $('.events-error', $module);
    const eventsLoading = $('.events-loading', $module);
    let $events = $('.events', $module);
    eventsEmpty.hide();
    eventsError.hide();
    eventsLoading.show();
    const endpoint = `/${currentEnvironment.language}/events`;
    const limit = 12;
    const offset = 0;
    getEvents(endpoint, limit, offset).then(result => {
        if ((result.count || 0) === 0) {
            eventsEmpty.show();
            eventsLoading.hide();
            return;
        }
        eventsLoading.hide();
        $events.attr('data-totalslides', result.count);
        $events.attr('data-offset', result.data.length);
        $events.append(createEvent(result, $events));

        $events.slick({
            variableWidth: true,
            infinite: false,
            slidesToShow: 3,
            slidesToScroll: 1,
            prevArrow: '<button class="slick-prev event-prev" aria-label="Previous" type="button"><img src="/assets/img/icons/icon_dark_arrowprev@3x.svg" alt="Previous"/></button>',
            nextArrow: '<button class="slick-next event-next" aria-label="Next" type="button"><img src="/assets/img/icons/icon_dark_arrownext@3x.svg" alt="Next"/></button>',
            responsive: [
                {
                    breakpoint: 1105,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 725,
                    settings: {
                        slidesToShow: 1,
                    }
                }
            ],
        }).show();
    })

    $events.on('click', '.event-next', function () {
        const activeSlide = $events.slick('slickCurrentSlide');
        const slidesToShow = parseInt($events.slick('slickGetOption', 'slidesToShow'), 10);
        const visibleIndex = activeSlide + slidesToShow + 2;
        let currentOffset = parseInt($events.attr('data-offset'), 10);
        const totalSlides = parseInt($events.attr('data-totalslides'), 10);
        if (visibleIndex === currentOffset && currentOffset < totalSlides) {
            loadingEffect($events, true);
            getEvents(endpoint, limit, currentOffset).then(result => {
                    loadingEffect($events, false);
                    currentOffset += result.data.length;
                    $events.attr('data-offset', currentOffset);
                    for (let item of result.data) {
                        $events.slick('slickAdd', createCard(item));
                    }
                }
            )
        }
    });

})

function getEvents(endpoint, limit, offset) {
    const data = {
        limit: limit,
        offset: offset,
    }
    return Promise.resolve($.ajax({
        type: 'GET',
        url: endpoint,
        data,
        dataType: 'json',
    }))
}

function createEvent(results, el) {
    let html = $('<div class="events-items" />');
    let elements = []
    if (results.count) {
        const events = results.data;
        if (events.length > 1) {
            for (let event of events) {
                elements.push(createCard(event))
            }
        }
    }
    return el.append(elements)
}

function createCard(data) {
    return `<div><div class="item"><a href ="${data.url}" title = "${data.headline}" tabIndex = "0" >
<div class ="bg" data-display = "default" style = "background-image: ${getBgStyling(data, '480x270')};" ></div>
<div class="bg" data-display="large" style="background-image: ${getBgStyling(data, '640x360')};"></div>
<div class="bg" data-display="vertical" style="background-image: ${getBgStyling(data, '320x360')};"></div>
<div class="text expanded"><h3 className="text-ellipsis-2">${data.headline}</h3><span>${data.date}</span></div>
<img class="iconContentType" src="/assets/img/icons/@0,5xicon_img_stopwatch.svg" alt="article"></a></div></div>`
}

